import Section from "components/Section"
import styles from "./BlogList.module.scss"
import { BlogListItem } from "./BlogListItem"
import cn from "classnames"

const BlogList = ({
  headlineType = "h1",
  headlineItemType = "h2",
  title = "",
  headline = "",
  blogPosts,
  content,
}) => {
  const HeadlineType = headlineType

  if (!blogPosts?.length) return null

  return (
    <Section
      className={cn(styles.blogList, {
        [styles[`blogList--${content.locale}`]]: content.locale,
      })}
    >
      {headline || title ? (
        <HeadlineType className={`h2 ${styles.blogListTitle}`}>
          {headline ? headline : title}
        </HeadlineType>
      ) : null}
      {blogPosts && (
        <div className={styles.list}>
          {blogPosts.map((post) => (
            <BlogListItem
              content={content}
              key={post.id}
              item={post}
              headlineItemType={headlineItemType}
            />
          ))}
        </div>
      )}
    </Section>
  )
}

export default BlogList
